import { useEffect, useState } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_fa6bf9ff2b16e2d755d711c0dc81251d_c413461c.jpg"
          alt="まごころサービス - 温かいケア"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* ナビゲーション */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/5e5f957ef398d7b7e688123f7d43a515/6af3d63b7347a7162ba15b1cbc9a002c.jpeg" 
              alt="まごころサービス ロゴ" 
              className="w-12 h-12 object-contain"
            />
            <h1 className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-800' : 'text-white'}`} style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
              まごころサービス
            </h1>
          </div>
          <ul className="hidden md:flex items-center gap-8">
            <li><a href="#services" className={`text-sm font-medium transition-colors hover:text-orange-400 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>サービス紹介</a></li>
            <li><a href="#philosophy" className={`text-sm font-medium transition-colors hover:text-orange-400 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>まごころの理念</a></li>
            <li><a href="#testimonials" className={`text-sm font-medium transition-colors hover:text-orange-400 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>お客様の声</a></li>
            <li><a href="#contact" className={`text-sm font-medium transition-colors hover:text-orange-400 whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>お問い合わせ</a></li>
          </ul>
          <button className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
          </button>
        </div>
      </nav>

      {/* ヒーローコンテンツ */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        <h2 className="text-5xl md:text-7xl font-black text-white mb-4" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
          あなたの大切な毎日に、
        </h2>
        <p className="text-4xl md:text-5xl font-medium text-white mb-6" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
          まごころを込めて。
        </p>
        <p className="text-base md:text-lg text-white/95 mb-10 leading-relaxed font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          介護保険外サービスでも、変わらぬ安心と笑顔をお届けします
        </p>
        <a 
          href="#contact" 
          className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-400 to-pink-400 text-white px-10 py-4 rounded-full text-base font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          無料相談はこちら
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
      </div>

      {/* スクロールインジケーター */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
